export const parseDomain = (domain: string) => {
  if (domain.includes("http")) {
    // Domain includes http already so it is probably complete
    return domain.replace(/\/$/, "");
  }

  if (domain.includes("localhost")) {
    // Domain is localhost, specify default port if not provided
    const localhostParts = domain.split(":");

    return `http://${localhostParts[0]}:${localhostParts[1] || "8000"}`;
  }

  const parts = domain.split(".");

  if (parts.length <= 1 && parts[0].includes("-api")) {
    // Domain is probably a subdomain, e.g. "develop-api"
    return `https://${parts[0]}.certn.co`;
  }

  if (parts.length <= 1) {
    // Domain is probably a environment name e.g. "develop"
    return `https://${parts[0]}-api.certn.co`;
  }

  // Domain is probably a url without a scheme
  return `https://${domain.replace(/\/$/, "")}`;
};
